import { useTranslation } from 'react-i18next'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

export const accessTableHeaderItems = [
  {
    id: 'number',
    label: 'plate_number',
  },
  {
    id: 'date',
    label: 'created',
  },
  // {
  //   id: 'author',
  //   label: 'Автор',
  // },
  // {
  //   id: 'comments',
  //   label: 'Комментарий',
  // },
  {
    id: 'time',
    label: 'accesses_valid_until',
  },
  {
    id: 'listType',
    label: 'accesses_type',
  },
  {
    id: 'comment',
    label: 'comment',
  },
  {
    id: 'phone_number',
    label: 'contact',
  },
  {
    id: 'edit',
    label: '',
    align: 'right'
  }
]


const TableHeader = () => {
  const { t } = useTranslation()
  return (
    <TableHead>
      <TableRow>
        {
          accessTableHeaderItems.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.align || 'left'}
            >
              {t(headCell.label)}
            </TableCell>
          ))
        }
      </TableRow>
    </TableHead>
  )
}

export default TableHeader
